import styled from '@emotion/styled';
import { PriceIcon } from 'src/icons';
import { useMediaQuery, usePalette, useTranslation } from 'src/hooks';
import { transientOptions } from 'src/utils';
import { SvgIcon, Tooltip, Typography } from 'src/components/atoms';
import { Flex } from 'src/components/layout';

interface Props {
  text: number;
}

const StyledTooltip = styled(Tooltip, transientOptions)`
  grid-area: price;
  justify-self: center;
`;

export const Price = ({ text }: Props) => {
  const { t } = useTranslation();
  const { success } = usePalette();
  const matchesMobile = useMediaQuery('sm');

  return (
    <StyledTooltip title={t(`pages.feed.myme.price`)}>
      <Flex m={matchesMobile ? 0.5 : 1}>
        <SvgIcon sx={{ mr: 0.75, height: 12, width: 12 }}>
          <PriceIcon fill={success.main} />
        </SvgIcon>
        <Typography variant='body2' fontSize={12}>
          {`${text.toFixed(2)}€`}
        </Typography>
      </Flex>
    </StyledTooltip>
  );
};
